import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/img_confetti.webp")